import React from "react";

/**
 * Pipeline segments map to existing Schedule/Today legend + name colors in theme.scss
 * (`ces-cand-legend-dot--*` / `ces-cand-name--*`).
 */
export const CALL_EXECUTIVE_PIPELINE_TABS = [
  { key: "newLeads", label: "New Leads", variant: "not-called" },
  { key: "eligible", label: "Eligible", variant: "drug-eligible" },
  { key: "inProgress", label: "In progress", variant: "drug-order-mint" },
  { key: "scheduledVm", label: "Scheduled & VM", variant: "scheduled-drug-required" },
  { key: "vm", label: "VM", variant: "vm" },
];

/**
 * Horizontal pipeline strip above the Call Executive table — dot + label use shared CES candidate styles.
 */
const CallExecutivePipelineBar = ({
  activeKey = null,
  onTabChange,
  className = "",
}) => {
  return (
    <div className={`ces-pipeline-bar ${className}`.trim()}>
      <div className="ces-pipeline-bar__inner">
        {CALL_EXECUTIVE_PIPELINE_TABS.map((tab) => {
          const isActive = activeKey === tab.key;
          const v = tab.variant;
          return (
            <span
              key={tab.key}
              // type="button"
              className={`ces-pipeline-tab d-inline-flex align-items-center gap-1${
                isActive ? " is-active" : ""
              }`}
              onClick={() => {
                if (typeof onTabChange !== "function") return;
                if (isActive) onTabChange(null);
                else onTabChange(tab.key);
              }}
            >
              <span
                className={`ces-cand-legend-dot ces-cand-legend-dot--${v}`}
                aria-hidden
              />
              <span className={`ces-cand-name ces-cand-name--${v}`}>
                {tab.label}
              </span>
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default CallExecutivePipelineBar;
